/**
 * The payload of a JWT, read WITHOUT verifying it. The gateway authorizer verifies; the client
 * only needs to know whose token it holds. Null for anything that is not a readable JWT.
 */
export function readJwtClaims(token: string | null | undefined): Record<string, unknown> | null {
  if (!token) return null;
  const parts = token.split('.');
  if (parts.length !== 3) return null;
  try {
    const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const binary = atob(base64 + '==='.slice((base64.length + 3) % 4));
    // percent-decode so a UTF-8 name in the payload survives atob's latin-1 output
    let escaped = '';
    for (let i = 0; i < binary.length; i += 1) escaped += '%' + ('0' + binary.charCodeAt(i).toString(16)).slice(-2);
    const claims: unknown = JSON.parse(decodeURIComponent(escaped));
    return claims && typeof claims === 'object' && !Array.isArray(claims) ? (claims as Record<string, unknown>) : null;
  } catch (error) {
    return null;
  }
}
